import i18n, { translate as t } from '@thoughtspot/i18n';
import { create } from '@thoughtspot/logger';
import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import { CustomChartError } from '../../../components/chart-error/chart-error.util';
import { ErrorTypes } from '../../../components/chart-error/chart-error.helper';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
import { mapCustomChartConfigToSDKConfig } from '../../../utils/custom-chart-config-adaptor.util';
import { validateCustomChartValidationEventResponsePayload } from '../../common/util';
const logger = create('ts-to-chart > event-callbacks > validate-chart-config');
export const validateCustomChartConfig = (commonProps, eventProps, emitEvent) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    const { customChartConfig, columns, columnProperties, updateCustomChartContext, } = eventProps;
    const chartConfig = mapCustomChartConfigToSDKConfig(customChartConfig, columns, columnProperties);
    const payload = {
        chartConfig,
    };
    return sendMessage(iframeRef, {
        eventType: TSToChartEvent.ChartConfigValidate,
        payload,
    }, appUrl).then(res => {
        const validationResponse = validateCustomChartValidationEventResponsePayload(res.data, logger);
        if (!validationResponse.isValid) {
            logger.error('Invalid response received from chart', validationResponse.validationErrorMessage);
            throw new CustomChartError(ErrorTypes.INIT_INVALID_CONFIG_ERROR);
        }
        const { chartConfigEditorDefinition, visualPropEditorDefinition, isValid, } = res.data;
        if (isValid) {
            updateCustomChartContext({
                updatedChartConfigEditorDefinition: chartConfigEditorDefinition,
                updatedVisualPropEditorDefinition: visualPropEditorDefinition,
            });
            return '';
        }
        let errorMessage = '';
        if (res.data.validationErrorMessage) {
            if (Array.isArray(res.data.validationErrorMessage)) {
                res.data.validationErrorMessage.forEach((error) => {
                    if (error?.errorTranslation) {
                        errorMessage += i18n.exists(error.errorTranslation)
                            ? t(error.errorTranslation)
                            : error.errorMessage;
                        errorMessage += '\n';
                    }
                    else {
                        errorMessage += error;
                        errorMessage += '\n';
                    }
                });
                errorMessage = errorMessage.trim();
            }
            else {
                errorMessage = res.data.validationErrorMessage;
            }
        }
        else {
            errorMessage = 'Config validation error : Empty message';
        }
        return errorMessage;
    });
};
//# sourceMappingURL=index.js.map